import React from 'react'
import ReactDOM from 'react-dom'
import DigitalMenu from './containers/DigitalMenu'

ReactDOM.render(<DigitalMenu/>, document.getElementById('root'))

